import { Component, Vue } from 'vue-property-decorator';
import WithRender from './UsersReport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class UsersReport extends Vue {
  isLoading = false;

  dateFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10);
  dateTo = new Date().toISOString().substr(0, 10);
  search = '';
  reachOutState: string = '';

  reachOutStateOptions = [
    { value: '', text: 'New' },
    { value: '1', text: 'Contacted' },
  ];

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    { key: "joinedOn",        label: "Joined On",      sortable: true },
    { key: "fullName",        label: "Full Name",      sortable: true },
    { key: "referror",        label: "Referror",       sortable: true },
    { key: "userName",        label: "Username",       sortable: true },
    { key: "email",           label: "Email",          sortable: true },
    { key: "whatsApp",        label: "WhatsApp",       sortable: true },
    { key: "agentCode",       label: "Agent Code",     sortable: true },
    { key: "streetAddress",   label: "Street Address", sortable: true },
    { key: "stateOrProvince", label: "Province",       sortable: true },
    { key: "postalCode",      label: "Postal Code",    sortable: true },
    { key: "balance",         label: "Balance",        sortable: true },
    { key: "reachOutState",   label: "State", sortable: true },
    { key: "reachOutStateUpdatedOn", label: "Contacted On", sortable: true },
    { key: "actions",         label: "",               sortable: false },
  ];

  mounted() {
    this.getReport();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    const reachOutParam = this.reachOutState !== '' ? `&reachOutState=${this.reachOutState}` : '';
    _axios.get(`${config.gateway}admin/internal/report/Users?dateFrom=${this.dateFrom}&dateTo=${this.dateTo}&currentPage=${this.currentPage}&pageSize=${this.perPage}&search=${this.search}${reachOutParam}`)
      .then(response => {
        this.items = response.data.objectList.map((u: any) => ({
          ...u,
          joinedOn: u.createdOn ? u.createdOn.substring(0, 10) : '-',
          reachOutState: u.reachOutState === 1 ? 'Contacted' : 'New',
          reachOutStateUpdatedOn: u.reachOutStateUpdatedOn ? u.reachOutStateUpdatedOn.substring(0, 10) : '-',
        }));
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }

  downloadCsv(): void {
    _axios.get(`${config.gateway}admin/internal/report/Users/GetCSV?dateFrom=${this.dateFrom}&dateTo=${this.dateTo}&search=${this.search}`, { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `users-signon-${this.dateFrom}-${this.dateTo}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(err => { console.error(err); });
  }

  exportCrmLeads(): void {
    const reachOutParam = this.reachOutState !== '' ? `&reachOutState=${this.reachOutState}` : '';
    _axios.get(`${config.gateway}admin/internal/report/Users/ExportCrmLeadsXls?dateFrom=${this.dateFrom}&dateTo=${this.dateTo}&search=${this.search}${reachOutParam}`, { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `crm-leads-${this.dateFrom}-${this.dateTo}.xls`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(err => { console.error(err); });
  }
}
